import styled from "styled-components";

export default styled.div`
  position: relative;
  width: 100%;
  max-width: ${(props) => props.theme.sizes.maxLayoutWidth};
  margin: 0 auto;
`;
